import React from 'react'
import type { CloudMarketplace } from '../../types/marketplace'
import aws from '../../images/aws.png'
import azure from '../../images/azureMarketPlace.png'
import gcp from '../../images/gcpMarketPlace.png'

export type MarketplaceIconClasses = {
  awslogo: string
  azurelogo: string
  gcpLogo: string
}

export type MarketplaceIconProps = {
  classes: MarketplaceIconClasses
  cloudMarketplace: CloudMarketplace
}

export const MarketplaceIcon = React.memo(
  ({ classes, cloudMarketplace }: MarketplaceIconProps) => {
    switch (cloudMarketplace) {
      case 'AWS':
        return (
          <img
            className={classes.awslogo}
            src={aws}
            alt="aws"
            data-testid="aws-logo"
          />
        )
      case 'AZURE':
        return (
          <img
            className={classes.azurelogo}
            src={azure}
            alt="azure"
            data-testid="azure-logo"
          />
        )
      case 'GCP':
      case 'REDHAT':
        return (
          <img
            className={classes.gcpLogo}
            src={gcp}
            alt={cloudMarketplace.toLowerCase()}
            data-testid={`${cloudMarketplace.toLowerCase()}-logo`}
          />
        )
      default:
        return null
    }
  }
)
